const ShareTeam = r => require.ensure(
  [],
  () => r(require('@/components/bloom-team/share-team')),
  'ShareTeam'
)

const teamHomepage = r => require.ensure(
  [],
  () => r(require('@/components/bloom-team/home')),
  'ShareTeam'
)
export default [
  // 任务列表
  {
    path: '/shareTeam',
    name: 'ShareTeam',
    component: ShareTeam,
    meta: {
      title: '邀请你加入我的团队…'
    }
  },
  {
    path: '/teamHomepage',
    name: 'teamHomepage',
    component: teamHomepage,
    meta: {
      noNeedShare: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/team.js